// libs
import styled, { css } from 'styled-components'
// themes
import colors from 'themes/colors'
// views
import { TextArea } from './components/RowCell/views'
// utils
import { darken } from 'polished'
import { isColorLight } from 'utils/tree'

const darkCellCSS = css`
  color: ${colors.white};
  background: ${colors.darkBlue500};
`

const darkTextAreaCSS = css`
  ${TextArea} {
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
  }
`

const MatrixContainer = styled.div`
  height: 100%;
  width: 100%;
  font-size: 14px;
`

const Row = styled.div<{
  color?: string
  isSelect?: boolean
  disabled?: boolean
  isSelected?: boolean
  showOptions?: boolean
  isSelectable?: boolean
}>`
  height: 100px;
  width: 200px;
  padding: 8px;
  min-width: 200px;
  background: ${colors.purple270};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 2px;

  ${({ isSelect, color, showOptions }) =>
    isSelect &&
    css`
      background: ${colors.gray230};
      color: ${colors.gray400};
      cursor: ${color ? 'pointer' : showOptions ? 'pointer' : 'default'};
    `};

  ${({ isSelect, color }) =>
    isSelect &&
    color &&
    css`
      text-transform: uppercase;
      font-weight: bold;
      font-size: 16px;
      background: ${color};
      color: ${isColorLight(color) ? colors.black : colors.white};
    `};

  ${({ color, isSelected }) =>
    isSelected && `border: 3px solid ${color === colors.darkBlue500 ? colors.green600 : colors.darkBlue500};`};

  ${({ isSelectable }) =>
    isSelectable &&
    css`
      > * {
        cursor: pointer;
      }
    `};

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: default;
    `};

  textarea {
    resize: none;
    background: ${colors.purple270};
    border: none;
    color: ${colors.black};
    outline: none;
    height: 100px;
    padding: 12px;
    text-align: center;

    ::placeholder {
      color: ${colors.black};
      text-align: center;
      line-height: 70px;
    }
  }

  &:hover {
    svg {
      display: inherit;
    }
  }

  svg {
    position: absolute;
    top: 0;
    right: 6px;
    z-index: 10;
    display: none;

    path {
      fill: ${({ color }) => (isColorLight(color) ? colors.black : colors.white)};
    }
  }
`

const ButtonsWrapper = styled.div<{ disabled?: boolean }>`
  min-width: 48px;

  svg {
    align-self: end;
    cursor: pointer;

    &:hover {
      path {
        fill: ${darken(0.1, colors.blue500)};
      }
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      svg:first-child {
        pointer-events: none;
        cursor: default;

        path {
          fill: ${colors.gray400};
        }

        &:hover {
          path {
            fill: ${colors.gray400};
          }
        }
      }
    `}
`

const MatrixBottomSection = styled.div`
  display: flex;
`

export { Row, MatrixBottomSection, MatrixContainer, ButtonsWrapper, darkCellCSS, darkTextAreaCSS }
